export default {
  cloneFromType: {
    survey: 'Encuesta',
    template: 'Plantilla',
  },
  createSurvey: 'Crear encuesta',
  createTemplate: 'Crear plantilla',
  newSurvey: 'Nueva encuesta',
  newSurveyFromScratch: 'Nueva encuesta desde cero',
  newTemplate: 'Nueva plantilla',
  newTemplateFromScratch: 'Nueva plantilla desde cero',
  source: {
    label: 'Fuente',
    arena: 'Arena (.zip)',
    collect: 'Collect (.collect, .collect-backup, .collect-data)',
    odk: 'ODK (.xml)',
  },
  startImport: 'Iniciar importación',
  survey: 'Encuesta',
  survey_other: 'Encuestas',
  template: 'Plantilla',
  template_other: 'Plantillas',
  error: 'Error al crear nueva encuesta',
  errorMaxSurveysCountExceeded:
    'Error al crear la encuesta; ha alcanzado el número máximo de encuestas que puede crear ({{maxSurveysCount}}).',
  options: {
    includeData: 'Incluir datos',
  },
}
